<template>
  <div class="mt-4 mx-3 row white-box px-3 py-4">
    <div class="white-box-top"></div>
    <div class="col-md-4 col-lg-2">
      <nav class="left-nav">
        <button
          class="btn w-100 text-start"
          v-on:click="active = 'warehouses'"
          :class="active === 'warehouses' ? 'btn-primary' : 'btn-simple'"
        >
          {{ $t("editUser.warehouses") }}
        </button>
      </nav>
    </div>
    <div class="col-md-8 col-lg-10" v-if="active == 'warehouses'">
      <h4>
        {{ $t("editUser.warehouses") }}
      </h4>
      <div
        v-for="warehouse in warehouses.filter((e) => e.is_closed !== true)"
        :key="warehouse.id"
      >
        <b>{{ warehouse.name }}</b>
        <OneByOneTable
          v-if="couriers[warehouse.id]?.length ?? 0 > 0"
          v-model:rows="courierRows"
          v-model:items="couriers[warehouse.id]"
          type="delivery"
          :empty-line="false"
          :show-add="false"
          :show-del="false"
          :key="key"
          v-on:update:field="(d, e, f) => update(warehouse.id, d, e, f)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import http from "@/modules/http";
import OneByOneTable from "@/components/lists/OneByOneTable.vue";
import { useStore } from "vuex";

export default {
  name: "Deliveries",
  components: { OneByOneTable },
  data() {
    return {
      store: useStore(),
      active: "warehouses",
      key: 0,
      couriers: {},
      courierRows: [
        {
          name: "Name",
          key: "courier_name",
          type: "text",
          show: true,
          editable: false,
        },
        {
          name: "Min daily parcels",
          key: "min_parcels",
          type: "number",
          show: true,
        },
        {
          name: "Max daily parcels",
          key: "max_parcels",
          type: "number",
          show: true,
        },
        {
          name: "Point",
          key: "point",
          type: "number",
          show: true,
        },
      ],
    };
  },
  computed: {
    warehouses() {
      return this.store.state.warehouses;
    },
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      http.fetch("/couriers/").then((data) => {
        this.couriers = data;
        this.key++;
      });
    },
    update(warehouse, data, key, val) {
      let send = {
        warehouse_id: warehouse,
      };
      if (data.courier_code) {
        send["courier_code"] = data.courier_code;
      }
      if (data.app_id) {
        send["app_id"] = data.app_id;
      }
      send[key] = val;

      http.fetch("/couriers/parcel-limits", send, true);
    },
  },
};
</script>
